/* FOLLOWER BOOST — Hero V5.2 controller (finition cinématique). See fb-hero-v52-lib.js for the choreography notes. */
// Shopify serves unversioned asset URLs with a one-year cache, so the helper modules are imported
// through the versioned URLs printed by the section (data-lib / data-scene).
const HOST = document.querySelector('[data-fb-v52]');
const LIB = await import(HOST?.dataset.lib || './fb-hero-v52-lib.js');
globalThis.__fbV52lib = LIB;
const { sceneMethods } = await import(HOST?.dataset.scene || './fb-hero-v52-scene.js');
// V10 : écran vivant, orbite finale, signature animée (module optionnel : sans lui, comportement V9)
const V10MOD = HOST?.dataset.v10 ? (await import(HOST.dataset.v10).catch(() => null))?.V10 || null : null;
const { REDUCED, DESKTOP, LOW, clamp, smooth, span, WAVE, NET_GLOW, SERVICES, prng, parsePairs, piecewise, parseScreen, screenAt, loadSprites } = LIB;

const LABELS = {
  en: { Vues: 'Views', Commentaires: 'Comments', Partages: 'Shares', Membres: 'Members', 'Écoutes': 'Streams' },
  es: { Likes: 'Likes', Vues: 'Vistas', Followers: 'Seguidores', Commentaires: 'Comentarios', Stories: 'Historias', Partages: 'Compartidos', Membres: 'Miembros', 'Écoutes': 'Escuchas' },
  de: { Vues: 'Aufrufe', Followers: 'Follower', Commentaires: 'Kommentare', Partages: 'Shares', Membres: 'Mitglieder', 'Écoutes': 'Streams' },
  it: { Likes: 'Like', Vues: 'Visualizzazioni', Followers: 'Follower', Commentaires: 'Commenti', Stories: 'Storie', Partages: 'Condivisioni', Membres: 'Membri', 'Écoutes': 'Ascolti' },
  nl: { Vues: 'Views', Commentaires: 'Reacties', Partages: 'Shares', Membres: 'Leden', 'Écoutes': 'Streams' },
  pt: { Likes: 'Gostos', Vues: 'Visualizações', Followers: 'Seguidores', Commentaires: 'Comentários', Partages: 'Partilhas', Membres: 'Membros', 'Écoutes': 'Reproduções' },
  pl: { Likes: 'Polubienia', Vues: 'Wyświetlenia', Followers: 'Obserwujący', Commentaires: 'Komentarze', Stories: 'Relacje', Partages: 'Udostępnienia', Membres: 'Członkowie', 'Écoutes': 'Odtworzenia' },
  sv: {"Likes": "Likes", "Vues": "Visningar", "Followers": "Följare", "Commentaires": "Kommentarer", "Stories": "Stories", "Partages": "Delningar", "Membres": "Medlemmar", "Écoutes": "Strömningar"},
  da: {"Likes": "Likes", "Vues": "Visninger", "Followers": "Følgere", "Commentaires": "Kommentarer", "Stories": "Stories", "Partages": "Delinger", "Membres": "Medlemmer", "Écoutes": "Afspilninger"},
  nb: {"Likes": "Likes", "Vues": "Visninger", "Followers": "Følgere", "Commentaires": "Kommentarer", "Stories": "Stories", "Partages": "Delinger", "Membres": "Medlemmer", "Écoutes": "Avspillinger"},
  fi: {"Likes": "Tykkäykset", "Vues": "Katselukerrat", "Followers": "Seuraajat", "Commentaires": "Kommentit", "Stories": "Storyt", "Partages": "Jaot", "Membres": "Jäsenet", "Écoutes": "Toistot"},
  cs: {"Likes": "Lajky", "Vues": "Zhlédnutí", "Followers": "Sledující", "Commentaires": "Komentáře", "Stories": "Stories", "Partages": "Sdílení", "Membres": "Členové", "Écoutes": "Přehrání"},
  sk: {"Likes": "Lajky", "Vues": "Zhliadnutia", "Followers": "Sledovatelia", "Commentaires": "Komentáre", "Stories": "Stories", "Partages": "Zdieľania", "Membres": "Členovia", "Écoutes": "Prehratia"},
  hu: {"Likes": "Lájkok", "Vues": "Megtekintések", "Followers": "Követők", "Commentaires": "Kommentek", "Stories": "Stories", "Partages": "Megosztások", "Membres": "Tagok", "Écoutes": "Lejátszások"},
  ro: {"Likes": "Like-uri", "Vues": "Vizualizări", "Followers": "Urmăritori", "Commentaires": "Comentarii", "Stories": "Stories", "Partages": "Distribuiri", "Membres": "Membri", "Écoutes": "Redări"},
  el: {"Likes": "Likes", "Vues": "Προβολές", "Followers": "Ακόλουθοι", "Commentaires": "Σχόλια", "Stories": "Stories", "Partages": "Κοινοποιήσεις", "Membres": "Μέλη", "Écoutes": "Ακροάσεις"},
  bg: {"Likes": "Харесвания", "Vues": "Гледания", "Followers": "Последователи", "Commentaires": "Коментари", "Stories": "Stories", "Partages": "Споделяния", "Membres": "Членове", "Écoutes": "Слушания"},
  sl: {"Likes": "Všečki", "Vues": "Ogledi", "Followers": "Sledilci", "Commentaires": "Komentarji", "Stories": "Stories", "Partages": "Deljenja", "Membres": "Člani", "Écoutes": "Predvajanja"},
  lt: {"Likes": "Patiktukai", "Vues": "Peržiūros", "Followers": "Sekėjai", "Commentaires": "Komentarai", "Stories": "Stories", "Partages": "Pasidalijimai", "Membres": "Nariai", "Écoutes": "Perklausos"},
};
const LANG = (document.documentElement.lang || 'fr').slice(0, 2).toLowerCase();
// V11 : toute langue hors français et hors table → anglais.
const LABEL_MAP = LANG === 'fr' ? {} : LABELS[LANG] || LABELS.en;

/**
 * V8.3 — direction artistique « noir profond » : étalonnage GPU des images pré-rendues.
 * Les images (téléphone, faisceaux, anneaux, particules) restent celles d'origine ; seul le voile vert des tons
 * sombres/moyens est neutralisé et assombri, les hautes lumières lime (anneaux, écran) sont conservées.
 * Mêmes images, même timing : chaque atlas est téléversé une fois sur le GPU, puis chaque image affichée n'est
 * qu'un dessin étalonné par le shader. Sans GPU (ou atlas trop grand) : dessin 2D d'origine + filtre CSS approchant.
 */
function createGrade(src, k) {
  const out = document.createElement('canvas');
  out.className = 'fb-v52__seq fb-v52__seq--gl';
  out.setAttribute('aria-hidden', 'true');
  let gl;
  // Rendu logiciel (pas de GPU) : refusé → repli CSS, plus léger. ?fb_gl=1 force le WebGL (contrôle qualité).
  const force = /[?&]fb_gl=1\b/.test(location.search);
  try { gl = out.getContext('webgl', { alpha: false, antialias: false, depth: false, stencil: false, premultipliedAlpha: false, failIfMajorPerformanceCaveat: !force }); } catch { gl = null; }
  if (!gl) return null;
  const sh = (type, code) => { const s = gl.createShader(type); gl.shaderSource(s, code); gl.compileShader(s); return gl.getShaderParameter(s, gl.COMPILE_STATUS) ? s : null; };
  // p : coin du quad (0..1) ; s : rectangle source (uv) ; d : rectangle destination (clip space)
  const vs = sh(gl.VERTEX_SHADER, 'attribute vec2 p;uniform vec4 s;uniform vec4 d;varying vec2 uv;void main(){uv=s.xy+p*s.zw;gl_Position=vec4(mix(d.x,d.z,p.x),mix(d.y,d.w,p.y),0.,1.);}');
  const fs = sh(gl.FRAGMENT_SHADER, [
    'precision mediump float;varying vec2 uv;uniform sampler2D t;uniform float k;uniform float b;',
    'float ss(float a,float b,float x){float y=clamp((x-a)/(b-a),0.,1.);return y*y*(3.-2.*y);}',
    'void main(){vec3 c=texture2D(t,uv).rgb;float L=dot(c,vec3(.2126,.7152,.0722));',
    'float gd=clamp(max(c.g-max(c.r,c.b),0.)/(c.g+.001)*2.2,0.,1.);', // dominance verte
    'float hm=ss(.5,.88,L);', // hautes lumières lime conservées
    'vec3 o=mix(c,vec3(L)*vec3(.5,.52,.5),gd*(1.-hm)*k);',
    'o*=mix(1.,.5+.5*ss(.12,.6,L),k);', // voile sombre → noir profond
    // V10 : l'éclat blanc pré-rendu du point culminant devient une énergie lime contenue (b = 0 hors climax)
    'float sat=max(c.r,max(c.g,c.b))-min(c.r,min(c.g,c.b));float wh=ss(.36,.82,L)*(1.-clamp(sat*2.2,0.,1.));',
    'o=mix(o,vec3(.6,.86,.18)*(.16+.34*L),wh*b);',
    'gl_FragColor=vec4(o,1.);}',
  ].join(''));
  if (!vs || !fs) return null;
  const prog = gl.createProgram();
  gl.attachShader(prog, vs); gl.attachShader(prog, fs); gl.linkProgram(prog);
  if (!gl.getProgramParameter(prog, gl.LINK_STATUS)) return null;
  gl.useProgram(prog);
  gl.bindBuffer(gl.ARRAY_BUFFER, gl.createBuffer());
  gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([0, 0, 1, 0, 0, 1, 0, 1, 1, 0, 1, 1]), gl.STATIC_DRAW);
  const loc = gl.getAttribLocation(prog, 'p');
  gl.enableVertexAttribArray(loc);
  gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);
  const uS = gl.getUniformLocation(prog, 's');
  const uD = gl.getUniformLocation(prog, 'd');
  gl.uniform1f(gl.getUniformLocation(prog, 'k'), k);
  const uB = gl.getUniformLocation(prog, 'b');
  let burst = 0;
  const maxTex = gl.getParameter(gl.MAX_TEXTURE_SIZE) || 4096;
  const newTex = (source) => {
    const t = gl.createTexture();
    gl.bindTexture(gl.TEXTURE_2D, t);
    for (const [p, v] of [[gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE], [gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE], [gl.TEXTURE_MIN_FILTER, gl.LINEAR], [gl.TEXTURE_MAG_FILTER, gl.LINEAR]]) gl.texParameteri(gl.TEXTURE_2D, p, v);
    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGB, gl.RGB, gl.UNSIGNED_BYTE, source);
    return t;
  };
  const texs = new WeakMap(); // image décodée → texture (téléversée une seule fois)
  let copyTex = null;
  let lost = false;
  out.addEventListener('webglcontextlost', (e) => { e.preventDefault(); lost = true; out.remove(); src.classList.remove('is-src'); });
  src.after(out);
  src.classList.add('is-src');
  const size = () => { if (out.width !== src.width || out.height !== src.height) { out.width = src.width; out.height = src.height; } gl.viewport(0, 0, out.width, out.height); };
  return {
    get lost() { return lost; },
    /** V10 : intensité (0..1) du ré-étalonnage de l'éclat blanc pour l'image affichée. */
    set burst(v) { burst = v; },
    /** Dessine directement une image (ou une case d'atlas) étalonnée. false = image trop grande pour le GPU. */
    drawImg(img, sx, sy, sw, sh, dx, dy, dw, dh) {
      if (lost) return false;
      const iw = img.naturalWidth || img.width;
      const ih = img.naturalHeight || img.height;
      if (!iw || !ih || iw > maxTex || ih > maxTex) return false;
      let t = texs.get(img);
      if (!t) { t = newTex(img); texs.set(img, t); } else gl.bindTexture(gl.TEXTURE_2D, t);
      size();
      gl.uniform1f(uB, burst);
      const W = out.width, H = out.height;
      gl.uniform4f(uS, sx / iw, sy / ih, sw / iw, sh / ih);
      gl.uniform4f(uD, (dx / W) * 2 - 1, 1 - (dy / H) * 2, ((dx + dw) / W) * 2 - 1, 1 - ((dy + dh) / H) * 2);
      gl.drawArrays(gl.TRIANGLES, 0, 6);
      return true;
    },
    /** Repli : recopie le canvas 2D (une texture par image affichée). */
    render() {
      if (lost) return false;
      size();
      if (!copyTex) copyTex = newTex(src); else { gl.bindTexture(gl.TEXTURE_2D, copyTex); gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGB, gl.RGB, gl.UNSIGNED_BYTE, src); }
      gl.uniform1f(uB, burst);
      gl.uniform4f(uS, 0, 0, 1, 1);
      gl.uniform4f(uD, -1, 1, 1, -1);
      gl.drawArrays(gl.TRIANGLES, 0, 6);
      return true;
    },
  };
}

class FbHeroV52 {
  constructor(el) {
    this.el = el;
    this.pin = el.querySelector('.fb-v52__pin');
    this.track = el.querySelector('.fb-v52__track');
    this.canvas = el.querySelector('[data-v52-canvas]');
    this.ctx = this.canvas.getContext('2d', { alpha: false });
    const gk = parseFloat(el.dataset.gradeK);
    if (el.dataset.grade === 'on' && gk > 0) {
      this.grade = createGrade(this.canvas, Math.min(1, gk));
      if (!this.grade) el.dataset.grade = 'css';
    }
    this.tc = el.querySelector('[data-v52-trails]');
    this.tctx = this.tc.getContext('2d');
    this.pulse = el.querySelector('[data-v52-pulse]');
    this.ring = el.querySelector('[data-v52-ring]');
    this.fx = el.querySelector('[data-v52-fx]');
    this.copy = el.querySelector('.fb-v52__copy');
    this.actions = el.querySelector('.fb-hero__actions');
    this.map = parsePairs(el.dataset.map, [[0, 0], [1, 1]]);
    this.static = REDUCED.matches || LOW;
    this.p = this.static ? 0.93 : 0;
    this.logos = [...this.fx.querySelectorAll('.fb-v52__it')].map((n, i) => ({ n, kind: 'net', key: n.dataset.platform, i }));
    this.services = [];
    this.mode = '';
    this.visible = true;
    this.setMode();
    this.plan();

    loadSprites(el).then((sprites) => { this.sprites = sprites || {}; this.addServices(sprites); this.plan(); this.layout(); this.render(); });
    new ResizeObserver(() => { this.setMode(); this.layout(); this.render(); }).observe(this.pin);

    if (this.static) { el.classList.add('is-static', 'is-still'); this.layout(); this.render(); return; }
    el.classList.remove('is-static');
    this.initLife();
    if (V10MOD) { this.V10 = V10MOD; V10MOD.init(this); }
    new IntersectionObserver((en) => { this.visible = en[0].isIntersecting; if (this.visible) this.update(); }, { threshold: 0 }).observe(el);
    const onScroll = () => { if (!this.visible || this.sraf) return; this.sraf = requestAnimationFrame(() => { this.sraf = 0; this.update(); }); };
    // Horizon scrolls inside .page-wrapper on desktop (window on mobile): capture on document.
    document.addEventListener('scroll', onScroll, { passive: true, capture: true });
    window.addEventListener('resize', onScroll, { passive: true });
    this.layout();
    this.update();
    const start = () => (window.requestIdleCallback ? requestIdleCallback(() => this.loadFrames(), { timeout: 1200 }) : setTimeout(() => this.loadFrames(), 200));
    if (document.readyState === 'complete') start(); else window.addEventListener('load', start, { once: true });
  }

  /* ---------- frames ---------- */
  setMode() {
    const mode = DESKTOP.matches ? 'd' : 'm';
    if (mode === this.mode) return;
    this.mode = mode;
    this.base = this.el.dataset[mode === 'd' ? 'seqD' : 'seqM'] || '';
    this.count = Math.max(2, parseInt(this.el.dataset[mode === 'd' ? 'countD' : 'countM'], 10) || 2);
    this.frames = new Array(this.count);
    // V8: optional atlases (8 frames per image, interleaved: atlas a holds frames a, a+n, a+2n…), so the
    // regraded sequence ships as 9 files per format instead of 72 — every frame and the timing are unchanged.
    this.atlas = this.el.dataset[mode === 'd' ? 'atlasD' : 'atlasM'] || '';
    this.per = 8;
    this.cols = mode === 'd' ? 2 : 4;
    this.nAtlas = Math.ceil(this.count / this.per);
    this.screens = parseScreen(this.el.dataset[mode === 'd' ? 'screenD' : 'screenM'], mode === 'd' ? [[0, 0.66, 0.58]] : [[0, 0.5, 0.73]]);
    // phone footprint in frame coordinates (kept clear of logos/badges)
    this.phone = mode === 'd' ? { l: 0.47, r: 0.88, t: 0.5, b: 0.8 } : { l: 0.02, r: 0.98, t: 0.62, b: 0.9 };
    this.focus = mode === 'd' ? [0.62, 0.55] : [0.5, 0.62];
    this.loadGen = (this.loadGen || 0) + 1;
    if (this.started) this.loadFrames();
  }

  url(i) { return this.base.replace(/000\.webp/, `${String(i).padStart(3, '0')}.webp`); }

  loadAtlases() {
    const gen = this.loadGen;
    const rows = this.per / this.cols;
    let next = 0;
    const pump = () => {
      if (gen !== this.loadGen || next >= this.nAtlas) return;
      const a = next++;
      const img = new Image();
      img.decoding = 'async';
      img.src = this.atlas.replace(/a0\.webp/, `a${a}.webp`);
      const done = () => {
        if (gen === this.loadGen) {
          const sw = img.naturalWidth / this.cols;
          const sh = img.naturalHeight / rows;
          for (let j = 0; j < this.per; j++) {
            const i = a + this.nAtlas * j;
            if (i < this.count) this.frames[i] = { img, sx: (j % this.cols) * sw, sy: Math.floor(j / this.cols) * sh, sw, sh };
          }
          this.draw();
        }
        pump();
      };
      (img.decode ? img.decode() : new Promise((r, j) => { img.onload = r; img.onerror = j; })).then(done, () => pump());
    };
    for (let k = 0; k < 3; k++) pump();
  }

  loadFrames() {
    if (this.static || (!this.base && !this.atlas)) return;
    if (this.atlas) { this.started = true; this.loadAtlases(); return; }
    this.started = true;
    const gen = this.loadGen;
    const order = [];
    const seen = new Set();
    [16, 8, 4, 2, 1].forEach((s) => { for (let i = 0; i < this.count; i += s) if (!seen.has(i)) { seen.add(i); order.push(i); } });
    if (!seen.has(this.count - 1)) order.splice(1, 0, this.count - 1);
    let next = 0;
    const pump = () => {
      if (gen !== this.loadGen || next >= order.length) return;
      const i = order[next++];
      const img = new Image();
      img.decoding = 'async';
      img.src = this.url(i);
      const done = () => { if (gen === this.loadGen) { this.frames[i] = img; this.draw(); } pump(); };
      (img.decode ? img.decode() : new Promise((r, j) => { img.onload = r; img.onerror = j; })).then(done, () => pump());
    };
    for (let k = 0; k < 6; k++) pump();
  }

  measureHeader() {
    let h = 0;
    document.querySelectorAll('.shopify-section-group-header-group, header').forEach((n) => {
      const cs = getComputedStyle(n);
      if ((cs.position === 'sticky' || cs.position === 'fixed') && !n.closest('[data-fb-v52]')) h = Math.max(h, n.getBoundingClientRect().height + Math.min(0, parseFloat(cs.top) || 0));
    });
    if (h > 0 && h < 200) this.el.style.setProperty('--fb-v52-top', `${Math.round(h)}px`);
  }

  progress() {
    const runway = parseFloat(getComputedStyle(this.track, '::after').height) || 1;
    const stickTop = parseFloat(getComputedStyle(this.pin).top) || 0;
    const hr = this.track.getBoundingClientRect();
    const natural = hr.bottom - runway - this.pin.offsetHeight;
    return clamp((stickTop - natural) / Math.max(1, runway));
  }

  // V8.2 : la scène rattrape la position du scroll avec un lissage et une vitesse maximale réglables
  // (section Hero : « Lissage » / « Vitesse max »). Le défilement n'est jamais bloqué ni modifié.
  update() {
    this.target = this.progress();
    this.wakeLife();
    const tau = parseFloat(this.el.dataset.smoothMs) || 0;
    if (!tau) { this.p = this.target; this.render(); return; }
    if (!this.tick) { this.last = performance.now(); this.tick = requestAnimationFrame((t) => this.step(t)); }
  }

  step(now) {
    const dt = Math.min(64, Math.max(1, now - this.last));
    this.last = now;
    const tau = parseFloat(this.el.dataset.smoothMs) || 1;
    const rate = (parseFloat(this.el.dataset.maxRate) || 0) / 100; // part de l'animation par seconde
    let delta = (this.target - this.p) * (1 - Math.exp(-dt / tau));
    if (rate > 0) { const cap = (rate * dt) / 1000; delta = Math.max(-cap, Math.min(cap, delta)); }
    this.p += delta;
    if (Math.abs(this.target - this.p) < 0.0005) this.p = this.target;
    this.render();
    this.tick = this.p === this.target ? 0 : requestAnimationFrame((t) => this.step(t));
  }

  /* ---------- V10 : écran vivant dès l'ouverture (scènes 1–2) ----------
     Lueur qui respire sur l'écran + petits symboles (cœur, vue, abonné, commentaire, partage) qui en sortent.
     Boucle active seulement en haut de la piste (p < 0.16), onglet visible et section à l'écran ; aucun chiffre. */
  initLife() {
    const scene = this.el.querySelector('[data-v52-scene]');
    this.life = document.createElement('div');
    this.life.className = 'fb-v52__life';
    this.life.setAttribute('aria-hidden', 'true');
    this.life.innerHTML = '<span class="fb-v52__glow"></span><span class="fb-v52__ripple"></span>';
    scene.insertBefore(this.life, this.fx);
    this.pings = 0;
    this.nextPing = 0;
    this.pingSeq = 0;
    document.addEventListener('visibilitychange', () => this.wakeLife());
  }

  wakeLife() {
    if (!this.life || this.lifeRaf || !this.visible || document.hidden || this.p >= 0.16) return;
    this.lifeRaf = requestAnimationFrame((t) => this.lifeStep(t));
  }

  lifeStep(t) {
    this.lifeRaf = 0;
    if (!this.visible || document.hidden || this.p >= 0.16 || !this.cover || !this.L) return;
    if (t >= this.nextPing && this.pings < 5) { this.spawnPing(); this.nextPing = t + 620 + ((this.pingSeq * 397) % 480); }
    this.lifeRaf = requestAnimationFrame((u) => this.lifeStep(u));
  }

  spawnPing() {
    const keys = ['heart', 'eye', 'user', 'heart', 'bubble', 'eye'];
    const k = keys[this.pingSeq % keys.length];
    const r = prng(this.pingSeq * 7919 + 13);
    this.pingSeq++;
    const n = document.createElement('span');
    n.className = 'fb-v52__ping';
    const src = this.sprites && this.sprites[k];
    n.innerHTML = src ? `<img src="${src}" alt="" width="40" height="40" decoding="async">` : '<i></i>';
    const L = this.L;
    n.style.setProperty('--dx', `${((r() - 0.5) * L * 2.4).toFixed(1)}px`);
    n.style.setProperty('--dy', `${(-L * (1.5 + r() * 1.1)).toFixed(1)}px`);
    n.style.setProperty('--rot', `${((r() - 0.5) * 24).toFixed(1)}deg`);
    this.life.appendChild(n);
    this.pings++;
    const done = () => { n.remove(); this.pings--; };
    n.addEventListener('animationend', done, { once: true });
    setTimeout(() => { if (n.isConnected) done(); }, 2600);
  }

  renderLife(S) {
    if (!this.life) return;
    const on = 1 - smooth(span(this.p, 0.05, 0.15));
    this.life.style.opacity = on.toFixed(3);
    this.life.style.visibility = on > 0.01 ? '' : 'hidden';
    this.life.style.transform = `translate3d(${S.x.toFixed(1)}px, ${S.y.toFixed(1)}px, 0)`;
    this.life.style.setProperty('--fb-v52-life', `${Math.round(this.L)}px`);
  }

  /* ---------- content ---------- */
  addServices(sprites) {
    if (this.services.length) return;
    SERVICES.forEach(([k, label, c], j) => {
      if (!sprites || !sprites[k] || k === 'share') return; // V10 : pictogramme « flèche » retiré (peu lisible)
      const n = document.createElement('span');
      n.className = 'fb-v52__svc';
      n.style.setProperty('--gc', c);
      const lbl = LABEL_MAP[label] || label; // V11 : libellés traduits
      n.innerHTML = `<span class="fb-v52__orb"><img src="${sprites[k]}" alt="" width="64" height="64" decoding="async"></span><b class="fb-v52__lbl">${lbl}</b>`;
      this.fx.appendChild(n);
      this.services.push({ n, orb: n.firstChild, kind: 'svc', key: k, i: j, col: c });
    });
  }

  /* timing of every element (pure data, independent of the viewport) */
  plan() {
    const rnd = prng(5202);
    const w = [[], [], []];
    this.logos.forEach((f) => { f.wave = WAVE[f.key] ?? 2; w[f.wave].push(f); });
    // wave 0 is in the air at p = 0; waves 1 and 2 emerge one after another from the screen
    w[0].forEach((f, k) => { f.e0 = -0.2; f.e1 = -0.05; f.rank = k; });
    w[1].forEach((f, k) => { f.e0 = 0.13 + k * 0.035; f.e1 = f.e0 + 0.09; f.rank = k; });
    w[2].forEach((f, k) => { f.e0 = 0.3 + k * 0.028; f.e1 = f.e0 + 0.09; f.rank = k; });
    this.logos.forEach((f, k) => {
      f.n.style.setProperty('--gc', NET_GLOW[f.key] || '#b7ff3c');
      f.n.style.setProperty('--d', `${(-k * 0.61).toFixed(2)}s`);
      f.plane = k % 3 === 0 ? 2 : k % 3 === 1 ? 1 : 0; // explosion depth: 2 front, 1 mid, 0 back
      f.dl = rnd() * 0.035; // explosion stagger
      f.side = rnd() < 0.5 ? -1 : 1;
      f.spin = (rnd() - 0.5) * 50;
    });
    this.services.forEach((f, k) => {
      f.e0 = 0.5 + k * 0.02;
      f.e1 = f.e0 + 0.07;
      f.dl = 0.02 + rnd() * 0.04;
      f.side = k % 2 ? 1 : -1;
      // short labels: shown while the service arrives, then only the 4–5 main ones at the climax
      f.lblA = f.e0 + 0.02;
      f.lblB = f.e0 + 0.07;
      f.hero = k < (this.mode === 'd' ? 5 : 4);
    });
  }

  /* ---------- rendering ---------- */
  draw() {
    if (!this.cover || !this.frames) return;
    const target = Math.round(clamp(piecewise(this.map, this.p)) * (this.count - 1));
    let idx = -1;
    for (let d = 0; d < this.count; d++) {
      if (this.frames[target - d]) { idx = target - d; break; }
      if (this.frames[target + d]) { idx = target + d; break; }
    }
    if (idx < 0 || (this.drawn && idx === this.shown)) return;
    const c = this.cover;
    const k = this.dpr;
    const fr = this.frames[idx];
    const img = fr.img || fr;
    const [sx, sy, sw, sh] = fr.img ? [fr.sx, fr.sy, fr.sw, fr.sh] : [0, 0, fr.naturalWidth, fr.naturalHeight];
    // V10 : l'éclat blanc des images ~38–50 (climax) est ré-étalonné en lime par le shader, progressivement.
    if (this.grade) { const t = idx / Math.max(1, this.count - 1); this.grade.burst = smooth(span(t, 0.36, 0.42)) * (1 - smooth(span(t, 0.72, 0.8))); }
    // V8.3 : chemin GPU (image téléversée une fois, étalonnage dans le shader) ; sinon dessin 2D d'origine.
    if (!(this.grade && this.grade.drawImg(img, sx, sy, sw, sh, c.x * k, c.y * k, c.w * k, c.h * k))) {
      this.ctx.drawImage(img, sx, sy, sw, sh, c.x * k, c.y * k, c.w * k, c.h * k);
      if (this.grade && !this.grade.render()) { this.grade = null; this.el.dataset.grade = 'css'; }
    }
    this.shown = idx;
    if (!this.drawn) { this.drawn = true; this.el.classList.add('is-playing'); }
  }

  screenPoint(p) {
    const [sx, sy] = screenAt(this.screens, piecewise(this.map, p));
    return { x: this.cover.x + sx * this.cover.w, y: this.cover.y + sy * this.cover.h };
  }

  render() {
    const p = this.p;
    if (!this.static) this.draw();
    const el = this.el;
    const desk = this.mode === 'd';
    const cp = !desk && !this.static ? smooth(span(p, 0.05, 0.16)) : 0;
    el.style.setProperty('--cp', cp.toFixed(3));
    el.style.setProperty('--exit', smooth(span(p, 0.95, 1)).toFixed(3));
    // V8: brand signature in the last second of the hero (static / reduced motion: shown)
    el.style.setProperty('--sig', (this.static ? 1 : smooth(span(p, 0.94, 0.99))).toFixed(3));
    if (this.actions && !desk) this.actions.style.transform = cp ? `translate3d(0, ${(-(this.actTop - 12) * cp).toFixed(1)}px, 0)` : '';
    else if (this.actions) this.actions.style.transform = '';
    this.copy.classList.toggle('is-compact', cp > 0.5);
    if (!this.cover || !this.L) return;
    const S = this.screenPoint(p);
    this.renderLife(S);
    if (this.V10) this.V10.render(this, p, S);

    // emission pulses: one bump per emerging element + the big wave at 80 %
    let pulse = 0.25 + 0.35 * smooth(span(p, 0.12, 0.3));
    let since = 1;
    for (const f of [...this.logos, ...this.services]) {
      if (f.e0 < 0) continue;
      pulse += Math.exp(-(((p - f.e0) / 0.012) ** 2)) * 0.55;
      if (p >= f.e0) since = Math.min(since, (p - f.e0) / 0.05);
    }
    const wave = span(p, 0.8, 0.86);
    pulse += Math.sin(Math.PI * clamp(wave)) * 0.85 + smooth(span(p, 0.7, 0.8)) * 0.4; // V10 : impulsion lime plus contenue (1.4 → 0.85)
    pulse *= 1 - smooth(span(p, 0.94, 1)) * 0.6;
    pulse *= 0.72; // V8: softer emission, no white flash
    const pw = this.L * (desk ? 3.2 : 2.6);
    this.pulse.style.transform = `translate3d(${S.x.toFixed(1)}px, ${S.y.toFixed(1)}px, 0) translate(-50%, -50%) scale(${(0.7 + Math.min(1.6, pulse) * 0.45).toFixed(3)})`;
    this.pulse.style.opacity = Math.min(1, pulse).toFixed(3);
    this.pulse.style.width = `${pw}px`;
    this.pulse.style.height = `${pw * 0.62}px`;
    const rr = wave > 0 && wave < 1 ? wave : clamp(since);
    this.ring.style.transform = `translate3d(${S.x.toFixed(1)}px, ${(S.y + this.L * 0.25).toFixed(1)}px, 0) translate(-50%, -50%) scale(${(0.2 + rr * (wave > 0 && wave < 1 ? 5 : 1.6)).toFixed(3)}, ${(0.08 + rr * (wave > 0 && wave < 1 ? 1.6 : 0.5)).toFixed(3)})`;
    this.ring.style.opacity = (Math.max(0, 1 - rr) * (wave > 0 && wave < 1 ? 1 : 0.7)).toFixed(3);

    // elements
    for (const f of this.logos) {
      const s = this.state(f, p, S);
      f.s = s;
      f.n.style.opacity = s.op.toFixed(3);
      f.n.style.transform = `translate3d(${s.x.toFixed(1)}px, ${s.y.toFixed(1)}px, 0) translate(-50%, -50%) rotateY(${s.ry.toFixed(1)}deg) rotate(${s.rot.toFixed(1)}deg) scale(${s.sc.toFixed(3)})`;
      f.n.style.filter = s.blur > 0.05 ? `blur(${s.blur.toFixed(2)}px)` : '';
      f.n.style.zIndex = String(p > 0.8 && p < 0.95 ? 20 + f.plane * 10 : p >= 0.95 && f.rz !== undefined ? 30 + Math.round(f.rz * 8) : 30);
    }
    this._lbls = [];
    for (const f of this.services) {
      const s = this.state(f, p, S);
      f.n.style.opacity = s.op.toFixed(3);
      f.n.style.transform = `translate3d(${s.x.toFixed(1)}px, ${s.y.toFixed(1)}px, 0) translate(-50%, -50%) scale(${s.sc.toFixed(3)})`;
      f.orb.style.filter = s.blur > 0.05 ? `blur(${s.blur.toFixed(2)}px)` : ''; // label stays sharp
      const side = s.op > 0.5 && this.labelOn(f, p) ? this.labelSide(f, s) : 0;
      f.n.classList.toggle('is-labelled', side !== 0);
      if (side) f.n.classList.toggle('is-left', side < 0);
    }
    this.drawTrails(p, S);
  }

}

Object.assign(FbHeroV52.prototype, sceneMethods);

document.querySelectorAll('[data-fb-v52]').forEach((el) => { if (!el.__fbV52) el.__fbV52 = new FbHeroV52(el); });
document.addEventListener('shopify:section:load', (e) => { const el = e.target.querySelector('[data-fb-v52]'); if (el) el.__fbV52 = new FbHeroV52(el); });
